import MenuBar from "../../MenuBar/MenuBar";

export default function Hobbies() {
    return (
        <>
            <text>Hobbies</text>
            <MenuBar page={"/home"}/>
        </>
    )
}